;(function (W, $, D) {

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D)

  let $disclaimerPages, $disclaimerCategoryWrapper, $disclaimerCategory

  const oUtils = sg.utils


  let disclamer = (() => {

    let _initDomElements = () => {
      $disclaimerPages = $('.disclamer-pages .paragraph--type--disclaimer');
      $disclaimerCategoryWrapper = $('.disclaimer-category');
      $disclaimerCategory = $disclaimerCategoryWrapper.find('.paragraph--type--disclaimer');
    }

    /**
     * @function disclamerPagesEvent
     * Event on popin disclamer - Only on pages
     */
    let disclamerPagesEvent = () => {
      if($disclaimerPages.length > 0 && $disclaimerPages.is(':visible')){
        let $mask = $disclaimerPages.next('.mask-disclamer')
        oUtils.stuckPopin($disclaimerPages)

        $disclaimerPages.find('.close-disclamer.close-button').on('click', () => {
          if(window.history.length > 1){
            window.history.back()
          }else{
            window.location = '/';
          }
        })

        $disclaimerPages.find('.close-disclamer.agree-button').on('click', () => {
          _closeDisclamer($disclaimerPages, $mask)
        })

        $mask.on('click', () => {
          _closeDisclamer($disclaimerPages, $mask)
        })

        $disclaimerPages.find('.link-disagree.button').on('click', () => {
          if(window.history.length > 1){
            window.history.back()
          }else{
            window.location = '/';
          }
        })
      }
    },
    /**
     * @function disclamerCategoryEvent
     * Event on popin disclamer - Only on doc (base doc, liste doc...)
     */

    disclamerCategoryEvent = () => {
      if($disclaimerCategory.length > 0){
        const links = $('#search-documentation-results-wrapper .wrapper-doc .link, .paragraph--type--last-documents .link, .search-form-results .link');
        //click event on link with cat associate to a existing disclamer
        $(once('linkToCat', links)).on('click', (e) => {
          let $link   = $(e.currentTarget),
              linkCat = $link.attr('data-cat')

          if(typeof linkCat !== "undefined"){
            $disclaimerCategoryWrapper.map((i, el) => {
              if($(el).attr('id') === 'disclaimer-' + linkCat){
                //open disclaimer et redirect to this doc/link when user click on disclaimer's agree buttonx
                e.preventDefault()
                let $disclaimerToDisplay = $(el).find('.paragraph--type--disclaimer'),
                  $disclaimerAgreeBtn = $disclaimerToDisplay.find('.close-disclamer.agree-button')

                $disclaimerAgreeBtn.attr('data-href-doc', $link.attr('href'))
                _openDisclamer($disclaimerToDisplay, $(el).find('.mask-disclamer'))

                $(once('linkToCat', $disclaimerAgreeBtn)).on('click', (e) => {
                  let $url = $(e.currentTarget).attr('data-href-doc')
                  window.open($url, '_blank')
                  _closeDisclamer($disclaimerToDisplay, $(el).find('.mask-disclamer'))
                })
                oUtils.stuckPopin($disclaimerToDisplay)
              }
            })
          }
        })

        let $mask = $disclaimerCategory.next('.mask-disclamer')
        $disclaimerCategory.find('.close-disclamer.close-button').on('click', () => {
          _closeDisclamer($disclaimerCategory, $mask)
        })
        $mask.on('click', () => {
          _closeDisclamer($disclaimerCategory, $mask)
        })
        $disclaimerCategory.find('.link-disagree.button').on('click', () => {
          _closeDisclamer($disclaimerCategory, $mask)
        })
      }
    },

    _closeDisclamer = ($disclamer, $mask) => {
      $disclamer.hide()
      $mask.hide()
    },

    _openDisclamer = ($disclamer, $mask) => {
      $disclamer.show()
      $mask.show()
    },

    oMod = {
      initDom: _initDomElements,
      disclamerPagesEvent: disclamerPagesEvent,
      disclamerCategoryEvent: disclamerCategoryEvent
    }

    return oMod
  })()

  $D.ready(function () {
    disclamer.initDom();
    disclamer.disclamerPagesEvent()
    disclamer.disclamerCategoryEvent()
  }).ajaxSuccess(function(){
    disclamer.initDom();
    disclamer.disclamerCategoryEvent()
  })

})(window, window.jQuery, document, once)
